const ROUTE_PERMISSION_ALIASES: Record<string, string[]> = {
  '/data-source': ['/project-settings'],
};

export const normalizePath = (value: string) => {
  if (!value) {
    return '/';
  }

  const trimmedValue = String(value).trim();
  const pathWithLeadingSlash = trimmedValue.startsWith('/') ? trimmedValue : `/${trimmedValue}`;
  const normalizedPath = pathWithLeadingSlash.replace(/\/+$/, '');

  return normalizedPath === '' ? '/' : normalizedPath;
};

export const canonicalizePath = (value: string) => {
  return normalizePath(value)
    .toLowerCase()
    .replace(/[_\s]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/\//g, '')
    .replace(/-/g, '');
};

const matchesPermission = (permission: string, currentPath: string) => {
  const normalizedCurrentPath = normalizePath(currentPath);
  const canonicalCurrentPath = canonicalizePath(currentPath);
  const normalizedPermission = normalizePath(permission);
  const canonicalPermission = canonicalizePath(permission);
  const regexSafePermission = normalizedPermission
    .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/\/:\w+/g, '/[^/]+');

  const regex = new RegExp(`^${regexSafePermission}$`, 'i');

  return (
    regex.test(normalizedCurrentPath) ||
    canonicalPermission === canonicalCurrentPath ||
    normalizedCurrentPath === normalizedPermission ||
    normalizedCurrentPath.startsWith(`${normalizedPermission}/`)
  );
};

export const getPathPermissionCandidates = (currentPath: string) => {
  const normalizedCurrentPath = normalizePath(currentPath);
  const aliases = ROUTE_PERMISSION_ALIASES[normalizedCurrentPath] || [];

  return [normalizedCurrentPath, ...aliases];
};

export const hasPermissionForPath = (permissions: string[] = [], currentPath: string) => {
  const pathCandidates = getPathPermissionCandidates(currentPath);

  return permissions.some((permission) => {
    return pathCandidates.some((candidatePath) => matchesPermission(permission, candidatePath));
  });
};
